
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"

@Component
export default class MetricSquare extends Vue {
  @Prop({required: true})
  name: string

  @Prop({required: true})
  value: string

  @Prop({required: true})
  icon: string
}
